export default "__VITE_ASSET__4dbf0228__"